import { FormikHelpers } from 'formik';
import { useDispatch } from 'react-redux';
import { login } from '../../../../../api/auth/login';
import { useTranslation } from '../../../../../i18n/use-translation';
import { setModalAction } from '../../../../../store/modal/factory';
import { ActiveModal } from '../../../../enums/active-modal';
import { useRequest } from '../../../../hooks/use-request';
import { LoginData } from '../type/login-data';

export function useViewModel() {
  const dispatch = useDispatch();
  const { locale } = useTranslation();
  const { isLoading, action } = useRequest();

  const resetPasswordClickHandler = () => dispatch(setModalAction(ActiveModal.RESET_PASSWORD));

  const formSubmitHandler = async (data: LoginData, formik: FormikHelpers<LoginData>) =>
    action(async () => {
      const errors = await login(data, locale);

      if (Object.keys(errors as any).length) {
        // @ts-ignore
        formik.setErrors({ _username: errors });
      }
    });

  return {
    isLoading,
    resetPasswordClickHandler,
    formSubmitHandler,
  };
}
